module.exports = __webpack_public_path__ + "img/236.643ba187.jpg";